var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.25 7.5V10.5H7.5V15.75H10.5V10.5H12.75L13.5 7.5H10.5V6C10.5 5.80109 10.579 5.61032 10.7197 5.46967C10.8603 5.32902 11.0511 5.25 11.25 5.25H13.5V2.25H11.25C10.2554 2.25 9.30161 2.64509 8.59835 3.34835C7.89509 4.05161 7.5 5.00544 7.5 6V7.5H5.25Z","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

FacebookInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
